import { checkTradeWorkRadius } from 'lib/sdks/search';
import { FetchError } from 'lib/utils/fetch/errors';

export const getTradeRadius = async (
  selectedCategoryId: number,
  postcode: string,
  uniqueName: string,
): Promise<Boolean> => {
  try {
    await checkTradeWorkRadius({
      categoryId: selectedCategoryId,
      companyId: uniqueName,
      postcode,
    });
    return true; // within trade working radius
  } catch (error) {
    if (error instanceof FetchError && error.status === 404) {
      return false; // outside trade working radius
    }

    return true; // default if api fails
  }
};
